// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import etask from '/util/etask.js';
import * as api from '@pub/api.js';
import {mimic} from '@pub/store/user.js';
import {alert} from '@pub/comp/alert';

const show_mimic_error = query=>alert({
    text: `User is not found by query "${query}"`,
    negative: true,
});

export const mimic_by_query = query=>etask(function*(){
    if (!query)
        return;
    const {has, email} = yield api.has_user(query);
    if (!has)
        return show_mimic_error(query);
    mimic(email);
});
